<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            type="year"
            label="감사년도"
            name="selfInspectionYear"
            v-model="searchParam.selfInspectionYear"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="SELF_INSPECTION_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="selfInspectionTypeCd"
            label="자체감사종류"
            v-model="searchParam.selfInspectionTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="자체감사 목록"
      tableId="accidentSeq"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :columns="grid.columns"
      :data="grid.data"
      rowKey="selfInspectionResultId"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "compliance-pop",
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          plantCd: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            align: "center",
            sortable: true,
          },
          {
            name: "selfInspectionYear",
            field: "selfInspectionYear",
            label: "감사년도",
            align: "center",
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: "selfInspectionTitle",
            field: "selfInspectionTitle",
            label: "감사명",
            align: "left",
            sortable: true,
          },
          {
            name: "selfInspectionTypeName",
            field: "selfInspectionTypeName",
            label: "감사종류",
            align: "center",
            sortable: true,
          },
          {
            name: "selfInspectionStartDt",
            field: "selfInspectionStartDt",
            label: "감사시작일",
            align: "center",
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: "selfInspectionEndDt",
            field: "selfInspectionEndDt",
            label: "감사종료일",
            align: "center",
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: "selfInspectionStatusName",
            field: "selfInspectionStatusName",
            label: "LBLSTEPPROGRESS",
            align: "center",
            sortable: true,
          },
          {
            name: "approvalStatusName",
            field: "approvalStatusName",
            label: "결재상태",
            align: "center",
            sortable: true,
          },
        ],
        data: [],
        height: '500px'
      },
      searchParam: {
        plantCd: null,
        selfInspectionYear: null,
        selfInspectionTypeCd: null,
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    }
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sop.pca.result.info.list.url;

      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd;
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = "자체감사 상세"; // 자체감사 상세
      this.popupOptions.param = {
        selfInspectionResultId: (row ? row.selfInspectionResultId : ''),
        selfInspectionStatusCd: (row ? row.selfInspectionStatusCd : ''),
        sysRevision: (row ? row.sysRevision : ''),
      };
      this.popupOptions.target = () => import(`${"./complianceDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '자체감사를 선택하세요.', // 자체감사를 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  },
};
</script>
